
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sub/privacy-policy",
      function () {
        return require("private-next-pages/sub/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sub/privacy-policy"])
      });
    }
  